import React, { useState, useContext, useRef, useEffect } from 'react';
import RefsContext from '../../contexts/RefsContext';
import { styleNotAllowed } from '../../utils/styleUtils';
import TextoInput from '../common/textoInput';
import ListaLayers from '../common/listaLayers'
import ListaResumen from '../common/listaResumen';
import { EstadosWidgetCerca, TiposListaResumen } from '../../utils/enums';

function WidgetCerca({ featureLayers, listaResumenCerca, maximoItems }) {
    const { expandsWidgetsButtonsRef } = useContext(RefsContext);
    const { widget: widgetCerca } = expandsWidgetsButtonsRef.current.expands.cerca;
    const { widget: widgetSketch } = expandsWidgetsButtonsRef.current.expands.sketch;
    const [radio, setRadio] = useState(widgetCerca.radioActual);
    const radioRef = useRef(widgetCerca.radioActual);
    const [timeOutId, setTimeOutId] = useState(null);
    const [timeOutRunning, setTimeOutRunning] = useState(false);
    const [idLayerSeleccionado, setIdLayerSeleccionado] = useState(null);
    const drawing = widgetCerca.estado === EstadosWidgetCerca.drawing;
    const drawRunning = widgetCerca.estado === EstadosWidgetCerca.drawRunning;
    const drawn = widgetCerca.estado === EstadosWidgetCerca.drawn;
    const running = widgetCerca.estado === EstadosWidgetCerca.running;
    const executed = widgetCerca.estado === EstadosWidgetCerca.executed;

    const tiempoEsperaCambioRadio = 750;

    useEffect(() => {
        if (featureLayers.length > 0 && !idLayerSeleccionado){
            setIdLayerSeleccionado(featureLayers[0].id);
        }
    }, [featureLayers, idLayerSeleccionado]);

    if (!idLayerSeleccionado){
        return <span className='panelAviso panelColorAceptado'>No hay capas configuradas para este widget en el mapa</span>;
    }

    function handleChangeRadio(e){
        if (timeOutRunning){
            clearTimeout(timeOutId);
        }
        setTimeOutRunning(true);
        setTimeOutId(setTimeout(() => {
            widgetCerca.radioActual = radioRef.current; //Es necesario crear un ref, ya que no toma el estado actual del radio sino el estado con el que se creó el setTimeout
            setTimeOutRunning(false);
        }, tiempoEsperaCambioRadio));
        radioRef.current = e.target.value;
        setRadio(e.target.value);
    }
    function verRegistros(){
        if (widgetCerca.numRegistrosActual > maximoItems){
            alert(`Puedes ver el detalle de máximo ${maximoItems} registros.\nBusca en un área más pequeña`);
        } else {
            cambiarEstado(EstadosWidgetCerca.running);
        }
    }
    function cambiarEstado(estado){
        widgetCerca.estado = estado;
    }
    function toogleDrawing(){
        if (drawing || drawn){
            widgetCerca.estado = EstadosWidgetCerca.created;
        } else {
            widgetSketch.cancel(); //desactivar Sketch
            widgetCerca.estado = EstadosWidgetCerca.drawing;
        }
    }

    let aviso = "";
    let displayAviso = "none";
    let blinkAviso = false;
    if (drawing || drawRunning || drawn || running){
        displayAviso = "block";
        if (drawing){
            aviso = "Selecciona un punto en el mapa"
        } else if(drawRunning){
            aviso = "Calculando el número de registros..."
            blinkAviso = true;
        } else if(drawn){
            aviso = widgetCerca.numRegistrosActual + " registros encontrados";
        } else if(running){
            aviso = "Generando..."
            blinkAviso = true;
        }
    }
    const disableInputs = drawRunning || running || executed;

    return (
        <div className='customWidget'>
            <div className='customWidgetSection'>
                <TextoInput texto="Capa"/>
                <ListaLayers 
                    idLayerSeleccionado={idLayerSeleccionado}
                    handleCambioLayer={setIdLayerSeleccionado}
                    disabled={disableInputs}
                    featureLayers={featureLayers}
                    esWidgetCerca={true}
                />
            </div>
            <div className='customWidgetSection'>
                <TextoInput texto="Distancia (km)"/>
                <input type="number" className='esri-input' min={1} value={radio} onChange={handleChangeRadio} disabled={disableInputs ? "disabled" : ""} style={styleNotAllowed(disableInputs)}/>
            </div>
            <div className={'customWidgetSection customWidgetCentrado' + (blinkAviso ? " blink" : "")} style={{ display: displayAviso }}>
                <span className='customWidgetAvisoCentrado'>{aviso}</span>
            </div>
            <div className='customWidgetSection' style={{ display: (drawn || drawRunning) && widgetCerca.numRegistrosActual > 0 ? "block" : "none" }}>
                <button className='esri-button' onClick={verRegistros} disabled={timeOutRunning || drawRunning ? "disabled" : ""} style={styleNotAllowed(timeOutRunning || drawRunning)}>
                    Ver registros
                </button>
            </div>
            <div className='customWidgetSection' style={{ display: running || executed ? "none" : "block" }} >
                <button className='esri-button' onClick={toogleDrawing} disabled={drawRunning ? "disabled" : ""} style={styleNotAllowed(drawRunning)}>
                    {drawing || drawn || drawRunning ? "Cancelar" : "Seleccionar punto"}
                </button>
            </div>
            <div className='customWidgetSection' style={{ display: executed ? "block" : "none"}}>
                <button className='esri-button' onClick={() => {cambiarEstado(EstadosWidgetCerca.created); cambiarEstado(EstadosWidgetCerca.drawing)}}>
                    Borrar - Nueva búsqueda
                </button>
            </div>
            <div className='customWidgetSection customWidgetTableContainer' style={{ display: executed ? "block" : "none"}}>
                <ListaResumen
                    listaResumen={listaResumenCerca}
                    maximoItems={maximoItems}
                    tipoListaResumen={TiposListaResumen.cerca}
                />
            </div>
        </div>
    );
}

export default React.memo(WidgetCerca);